import fails$1 from './fails.js';
import global$1 from './global.js';

var fails = fails$1;
var global = global$1; // babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError

var $RegExp = global.RegExp;
var regexpUnsupportedDotAll = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

export { regexpUnsupportedDotAll as default };
